import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Access token lives in memory only; the HttpOnly cookie is the persistent session.
let accessToken = null;
localStorage.removeItem("toastern_token");

export const getToken = () => accessToken;
export const setToken = (t) => {
  accessToken = t || null;
};
export const clearToken = () => {
  accessToken = null;
};

client.interceptors.request.use((cfg) => {
  if (accessToken) cfg.headers.Authorization = `Bearer ${accessToken}`;
  return cfg;
});

export async function refreshSession() {
  const { data } = await axios.post(`${API}/auth/refresh`, null, { withCredentials: true });
  setToken(data.access_token);
  return data.user;
}

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config || {};
    const status = error.response?.status;
    if (status === 401 && !cfg._retried && !String(cfg.url || "").startsWith("/auth/")) {
      cfg._retried = true;
      try {
        await refreshSession();
        return client(cfg);
      } catch (e) {
        clearToken();
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
